var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iframe_url && _vm.iframe_url != '')?_c('iframe',{attrs:{"src":`${_vm.iframe_url}?data=${_vm.base64Params}`,"title":"urlAction"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }